var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"checkbox",class:{'checked': _vm.toggled},on:{"click":function($event){return _vm.toggleCheckbox()}}}),_c('div',{staticClass:"tape"})])}
var staticRenderFns = []

export { render, staticRenderFns }